import React from "react";
import { MarkerType } from "react-flow-renderer";

const level1 = "rgb(17,3,3, 0.1)";
const level2 = "#5d1c53";
const level3 = "rgb(20,28,39, 0.9)";
const level4 = "#3c5475";
const level5 = "#4517d1";
const level6 = "#de723a";
const black = "yellow";
const white = "white";
const transparent = "00FFFFFF";
const spaceColor = "#141c26";

export const nodes = [
  {
    id: "2",
    type: "input",
    data: {
      label: (
        <>
          <strong> Pseudo-selectors</strong>
        </>
      ),
    },
    position: { x: -370, y: 0 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "3",
    data: {
      label: (
        <>
          <strong> .class (aka .className if using React) </strong>
          <p>
            Utilize class names to target specific html elements with css by
            using the .class selector.
            <br /> <br />
            To select elements with a specific class, write a period (.)
            character, followed by the name of the class.
          </p>

          <p>
            By giving this {`<p>`} element a class name of something such as
            example1 like this
          </p>
          <p className="example123">
            {" "}
            {`<p class="example1"> TEXT HERE </p>`}{" "}
          </p>
          <p>
            we can access it with css like this to make the color of its font
            yellow.
            <br />
            {`{.example1{color: yellow}`}.
          </p>
        </>
      ),
    },
    position: { x: -1500, y: 500 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "4",
    data: {
      label: (
        <>
          <strong>#id selector</strong>
          <p>Styles the element with the specified id.</p>
          <p>
            Use this to style html elements through an id that you provide them
            with.{" "}
          </p>
          <p>
            Example: Let's give this span element an id of span123 like this
            <br />
            <br />
            {`<span id="span123"> TEXT </span>`}
          </p>
          <p>
            {" "}
            To target this in CSS you do <br />
            <br />
            <span id="span123">{`#span123{color: yellow;}`}</span>
            <br />
            <br />
            Which will make the text yellow.
          </p>
        </>
      ),
    },
    position: { x: 330, y: 500 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "5",
    data: {
      label: (
        <>
          <strong>*</strong>
          <p>This will select all elements in your webpage.</p>
          <iframe
            height="300"
            width="100%"
            scrolling="no"
            title="::placeholder"
            src="https://codepen.io/jonathanelias1/embed/preview/ExLwRwy?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/ExLwRwy">
              ::placeholder
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -522, y: 500 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "6",
    data: {
      label: (
        <>
          <strong>element</strong>
          <p>Use this to target every instance of a specific element name.</p>
          <p>
            Example: You have 4 paragraphs in your webpage and want them all to
            have a yellow font color. <br />
            {`<p> This is p1 </p>`} <br />
            {`<p> This is p2 </p>`} <br />
            {`<p> This is p3 </p>`} <br />
            {`<p> This is p4 </p>`}
          </p>
          <p>
            To target all of your paragraphs aka p elements at once you can do
            this.
            <br /> <br />
            {`p{color: yellow}`}
          </p>
          <p className="div123">
            {`<p> This is p1 </p>`} <br />
            {`<p> This is p2 </p>`} <br />
            {`<p> This is p3 </p>`} <br />
            {`<p> This is p4 </p>`}
          </p>
        </>
      ),
    },
    position: { x: 1200, y: 500 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "7",
    data: {
      label: (
        <>
          <strong>element, element</strong>
          <p>
            Style several elements with the same style by separating each
            element and/or class name with a comma
          </p>
          <p>
            Example:{" "}
            <span className="span56">
              <br />
              {`<span class=span56> This span will be yellow </span>`}
            </span>
            <br />
            <br />{" "}
            <p className="p64">
              {`<p class=p64> This p element will be also yellow </p>`}
            </p>
            {`.span56, .p64{color: yellow}`}
          </p>
        </>
      ),
    },
    position: { x: 260, y: 1634 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "8",
    data: {
      label: (
        <>
          <strong>element element</strong>
          <p>Used to select elements inside elements</p>
          <iframe
            height="700"
            width="100%"
            scrolling="no"
            title="element element"
            src="https://codepen.io/jonathanelias1/embed/preview/zYjEaXZ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/zYjEaXZ">
              element element
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2200, y: 1634 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "9",
    data: {
      label: (
        <>
          <strong>element{`>`}element</strong>
          <p>Used to select elements with a specific parent.</p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="element element"
            src="https://codepen.io/jonathanelias1/embed/preview/BaxwVgE?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/BaxwVgE">
              element element
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 726, y: 2666 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "10",
    data: {
      label: (
        <>
          <strong>element + element</strong>
          <p>
            Used to select an element that is directly after another specific
            element.
          </p>

          <iframe
            height="500"
            width="100%;"
            scrolling="no"
            title="element + element"
            src="https://codepen.io/jonathanelias1/embed/preview/yLjzqLO?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/yLjzqLO">
              element + element
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1196, y: 1634 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "11",
    data: {
      label: (
        <>
          <strong>element1~element2</strong>
          <p>
            Matches occurrences of element2 that are preceded by element1.
            <br />
            <br />
            Both elements must have the same parent, but element2 does not have
            to be immediately preceded by element1.
          </p>

          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="element + element"
            src="https://codepen.io/jonathanelias1/embed/preview/xxjXJZp?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/xxjXJZp">
              element + element
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1700, y: 2660 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "12",
    data: {
      label: (
        <>
          <strong>[attribute]</strong>
          <p>Used to select elements with the specified attribute.</p>
          <iframe
            height="700"
            width="100%;"
            scrolling="no"
            title="element + element"
            src="https://codepen.io/jonathanelias1/embed/preview/MWGEBEm?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/MWGEBEm">
              element + element
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -2500, y: 500 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "13",
    data: {
      label: (
        <>
          <strong>[attribute~=value]</strong>
          <p>
            Used to select elements with an attribute value containing a
            specified word.
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title="element + element"
            src="https://codepen.io/jonathanelias1/embed/preview/oNdGMpQ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/oNdGMpQ">
              element + element
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -3048, y: 1500 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "14",
    data: {
      label: (
        <>
          <strong>[attribute^=value]</strong>
          <p>
            Matches every element whose attribute value begins with a specified
            value.
          </p>

          <iframe
            height="600"
            width="100%"
            scrolling="no"
            title="attribute~=value"
            src="https://codepen.io/jonathanelias1/embed/preview/PoeJBaw?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/PoeJBaw">
              attribute~=value
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1837, y: 1500 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "15",
    data: {
      label: (
        <>
          <strong>[attribute$=value]</strong>
          <p>
            Matches every element whose attribute value ends with a specified
            value.
          </p>

          <iframe
            height="600"
            width="100%"
            scrolling="no"
            title="attribute~=value"
            src="https://codepen.io/jonathanelias1/embed/preview/RwyLBYX?default-tab=result&editable=true"
            frameborder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/RwyLBYX">
              attribute~=value
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -3048, y: 2440 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  {
    id: "16",
    data: {
      label: (
        <>
          <strong>[attribute*=value]</strong>
          <p>
            Matches every element whose attribute value contains a specified
            value.
          </p>

          <iframe
            height="600"
            width="100%"
            scrolling="no"
            title="attribute$=value"
            src="https://codepen.io/jonathanelias1/embed/preview/yLjzqQo?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/yLjzqQo">
              attribute$=value
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1837, y: 2440 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },
  // {
  //   id: "17",
  //   data: {
  //     label: (
  //       <>
  //         <strong></strong>
  //         <p></p>
  //       </>
  //     ),
  //   },
  //   position: { x: 0, y: 200 },
  //   style: {
  //     background: level3,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 300,
  //   },
  // },

  // End of items
];

export const edges = [
  //Pseudo-selectors
  {
    id: "e2-3",
    source: "2",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e2-4",
    source: "2",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e2-5",
    source: "2",
    target: "5",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e2-6",
    source: "2",
    target: "6",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e2-12",
    source: "2",
    target: "12",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //element
  {
    id: "e6-7",
    source: "6",
    target: "7",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e6-8",
    source: "6",
    target: "8",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e6-9",
    source: "6",
    target: "9",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e6-10",
    source: "6",
    target: "10",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e6-11",
    source: "6",
    target: "11",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //attribute

  {
    id: "e12-13",
    source: "12",
    target: "13",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e12-14",
    source: "12",
    target: "14",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e12-15",
    source: "12",
    target: "15",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e12-16",
    source: "12",
    target: "16",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  //     markerEnd: {
  //       type: MarkerType.ArrowClosed,
  //     },
  //   },

  //END
];
